<ndt-add-dashboard-tile-view
   [callState]="callState$ | async"
   [searchText]="searchText$ | async"
   [tileSets]="filteredTileSets$ | async"
   (addTile)="onAddTile($event)"
   (searchTextChange)="onSearchTextChange($event)"
   (formCanceled)="onCloseClick()"
></ndt-add-dashboard-tile-view>

<!-- [tileSets]="filteredTileSets$ | async" //[customTileSet]="customTileSet$ | async" -->
